import { HsIndexedGeometryData } from './indexed-geometry-data.class';
import type { HsRegularGeometryData } from './regular-geometry-data.class';

/**
 * Handles s index geometry.
 */
export function hsIndexGeometry(data: HsRegularGeometryData): HsIndexedGeometryData {
  const points: Map<string, number> = new Map<string, number>();
  const indices: number[] = [];
  for (let i: number = 0; i < data.vertices.length; i += 3) {
    const vertex: string = `${data.vertices[i]},${data.vertices[i + 1]},${data.vertices[i + 2]}`;
    const normal: string = `${data.normals[i]},${data.normals[i + 1]},${data.normals[i + 2]}`;
    const point: string = `${vertex},${normal}`;
    const existingIndex: number | undefined = points.get(point);
    if (existingIndex !== undefined) {
      indices.push(existingIndex);
    } else {
      indices.push(points.size);
      points.set(point, points.size);
    }
  }
  const vertices: number[] = [];
  const normals: number[] = [];
  points.forEach((_: number, point: string) => {
    const values: string[] = point.split(',');
    vertices.push(Number(values[0]), Number(values[1]), Number(values[2]));
    normals.push(Number(values[3]), Number(values[4]), Number(values[5]));
  });
  return new HsIndexedGeometryData(vertices, normals, indices);
}
